// extracted by mini-css-extract-plugin
export default {"notification":"G86iZaiOdz"};